// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-container {
  padding: 20px;
  border-radius: 8px;
  font-family: "Arial", sans-serif;
}
.timeline-container .timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.timeline-container .timeline-header .filter-btn,
.timeline-container .timeline-header .export-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #ddd;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
.timeline-container .timeline-header .timeline-range {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.timeline-container .timeline-header .timeline-range label {
  font-weight: 600;
  margin-bottom: 15px;
}
.timeline-container .timeline-header .timeline-range .date-range-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}
.timeline-container .timeline-header .timeline-range .date-range-inputs input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  width: 140px;
}
.timeline-container .timeline-header .timeline-range .date-range-inputs span {
  font-weight: bold;
  color: #333;
}
.timeline-container .timeline-content {
  font-size: 16px;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./src/pages/Timeline/Timeline.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,gCAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AACJ;AACI;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AACN;AAEI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAAN;AAEM;EACE,gBAAA;EACA,mBAAA;AAAR;AAGM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADR;AAGQ;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AADV;AAIQ;EACE,iBAAA;EACA,WAAA;AAFV;AAQE;EAEE,eAAA;EACA,WAAA;AAPJ","sourcesContent":[".timeline-container {\n  padding: 20px;\n  border-radius: 8px;\n  font-family: 'Arial', sans-serif;\n\n  .timeline-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n\n    .filter-btn,\n    .export-btn {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      background: #fff;\n      border: 1px solid #ddd;\n      padding: 6px 12px;\n      border-radius: 4px;\n      font-size: 14px;\n      cursor: pointer;\n    }\n\n    .timeline-range {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      label {\n        font-weight: 600;\n        margin-bottom: 15px;\n      }\n\n      .date-range-inputs {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n\n        input {\n          padding: 6px 10px;\n          border: 1px solid #ccc;\n          border-radius: 4px;\n          text-align: center;\n          width: 140px;\n        }\n\n        span {\n          font-weight: bold;\n          color: #333;\n        }\n      }\n    }\n  }\n\n  .timeline-content {\n    // width: 40%;\n    font-size: 16px;\n    color: #555;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
